import image from 'img/aside-promo-modal/partners.png';
import imageDark from 'img/aside-promo-modal/partnersDark.png';
import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { isPartnersFakedoor } from 'reactApp/appHelpers/featuresHelpers/features/partnersFakedoor';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { historyPush } from 'reactApp/modules/router/router.module';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getIdByStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { PartnersBlockId } from 'reactApp/sections/QuotaLanding/Partners/Partners.data';
import { store as reduxStore } from 'reactApp/store';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

import { PromoSelectors } from '../promo.selectors';

const PROMO_ID = 'partners-fakedoor-promo';

// НЕ ИСПОЛЬЗОВАТЬ: в большинстве случаев это приведет к багам
// promoShown должен отправляться в onShow, а removePromo – в onClose
// (и в onClick иногда)
function markPromoShown() {
    reduxStore.dispatch(promoShown(EPromoType.partnersDiscount));
    storeHelper.markAsShown(PROMO_ID);
    reduxStore.dispatch(removePromo(EPromoType.partnersDiscount));
}

export function* initParnersDiscountAsidePromoModal() {
    const storage = yield* select(getCurrentStorage);
    // Форс-включение промки для отдельных автотестов.
    const force = yield put(UserStorageActions.get(`force_${PROMO_ID}`)) || false;
    // Блок был показан на страницы промок-квоты
    const partnersBlockShown = yield put(UserStorageActions.get(PartnersBlockId)) || false;
    const isPaidUser = yield* select(UserSelectors.isPaidUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);

    if (
        !isPartnersFakedoor ||
        storeHelper.getValue(PROMO_ID) ||
        (IS_AUTO_TEST_HIDE && !force) ||
        storage !== EStorageType.home ||
        partnersBlockShown ||
        isBizUser ||
        isCorpUser
    ) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.partnersDiscount,
            promoId: PROMO_ID,
            onClick: () => {
                sendDwh({
                    eventCategory: ECategoryGa.balloon,
                    action: 'click',
                    dwhData: {
                        name: 'mnz_fake_offer',
                        is_paid: isPaidUser,
                    },
                });
                markPromoShown();
                reduxStore.dispatch(
                    historyPush({
                        id: getIdByStorage(EStorageType.quotaCleaner),
                        search: '?utm_source=cloud&utm_medium=web_union_quota_landing&utm_campaign=balloon_partners&utm_term=18089',
                        hash: 'partners',
                    })
                );
            },
            onShow: () => {
                sendDwh({
                    eventCategory: ECategoryGa.balloon,
                    action: 'show',
                    dwhData: {
                        name: 'mnz_fake_offer',
                        is_paid: isPaidUser,
                    },
                });
                markPromoShown();
            },
            onClose: () => {
                sendDwh({
                    eventCategory: ECategoryGa.balloon,
                    action: 'close',
                    dwhData: {
                        name: 'mnz_fake_offer',
                        is_paid: isPaidUser,
                    },
                });
                markPromoShown();
            },
        })
    );
}

export function* showParnersDiscountAsidePromoModal() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.partnersDiscount));

    if (promo) {
        const { onShow, onClick, onClose } = promo;
        const isDarkTheme = isDarkThemeModeEnabled();

        yield openAsidePromoModal({
            title: 'Партнёрские скидки с\u00A0Mail Space',
            text: 'Скидки до 30% в сервисах VK Музыка, Учи.ру, Касперский и других',
            buttonText: 'Подробнее',
            imageUrl: isDarkTheme ? imageDark : image,
            qaId: 'partners-aside-promo',
            textCompact: true,
            onShow,
            onClick,
            onClose,
        });
    }
}
